module.exports = __webpack_public_path__ + "img/HorizontalNegro1.6dacf0c2.png";